var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.25,
    height: 21.25,
    viewBox: "0 0 21.25 21.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-settings",
    "data-name": "Icon feather-settings",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M18.75,16.125A2.625,2.625,0,1,1,16.125,13.5,2.625,2.625,0,0,1,18.75,16.125Z",
    transform: "translate(-5 -5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M17.6,13.75a1.444,1.444,0,0,0,.289,1.593l.053.052a1.751,1.751,0,1,1-2.476,2.476l-.053-.053a1.455,1.455,0,0,0-2.468,1.033V19a1.75,1.75,0,0,1-3.5,0v-.079A1.444,1.444,0,0,0,8.5,17.6a1.444,1.444,0,0,0-1.593.289l-.053.053a1.751,1.751,0,1,1-2.476-2.476l.053-.053A1.455,1.455,0,0,0,3.4,12.945H3.25a1.75,1.75,0,0,1,0-3.5h.079A1.444,1.444,0,0,0,4.65,8.5a1.444,1.444,0,0,0-.289-1.593l-.053-.053A1.751,1.751,0,1,1,6.785,4.379l.053.053A1.444,1.444,0,0,0,8.43,4.72H8.5A1.444,1.444,0,0,0,9.375,3.4V3.25a1.75,1.75,0,0,1,3.5,0v.079a1.455,1.455,0,0,0,2.468,1.033l.052-.053a1.751,1.751,0,1,1,2.476,2.476l-.052.053A1.444,1.444,0,0,0,17.53,8.43V8.5a1.444,1.444,0,0,0,1.321.875H19a1.75,1.75,0,0,1,0,3.5h-.079a1.444,1.444,0,0,0-1.321.875Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.f2c8f9fbd53c551d0506a4500ca92924.svg";
export { ForwardRef as ReactComponent };